export const SAMPLE_NICKNAMES = [
  'Geniusboy',
  'Tryhardo',
  'Sleeplesso',
  'Burnouty',
  'Protesto',
  'Caffiend',
  'Overthinker',
  'Ghostlet',
  'Menacey',
  'Casualto',
  'Nerdling',
  'Midtermer',
  'Telegrapher',
  'Sprouler',
  'Bearwreck',
  'Nerd',
  'Hardcore',
  'Workaholic',
  'Raver',
  'Bookworm',
  'Night-owl',
  'Early-bird',
  'Overachiever',
  'Daydreamer',
  'Perfectionist',
  'Minimalist',
  'Maximalist',
  'Strategist',
  'Creative',
  'Analyst',
  'Wildcard',
  'Optimist',
  'Realist',
];
